import PropTypes from 'prop-types'
import { useState } from 'react'

import {
  Typography,
  TextField,
  Autocomplete,
  FormHelperText,
  Box,
} from '@mui/material'
import useAddressPredictions from './useAddressPredictions'
import getAddressDetail from './getAddressDetail'

import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'

const GPlacesAutocomplete = ({
  onChangeAddress,
  onChangeInput,
  error,
  countryRestrictions,
  sx,
  isRequired,
}) => {
  const t = useTranslations()

  const [input, setInput] = useState('')

  const predictions = useAddressPredictions(input, countryRestrictions)

  const handleChangeAddress = async value => {
    if (!Boolean(value)) {
      onChangeAddress(null)
    } else {
      const { place_id } = value
      getAddressDetail(place_id, onChangeAddress)
    }
  }

  const handleChangeInput = value => {
    setInput(value)
    //NOTE: onChangeInput is used to reset error messages
    onChangeInput()
  }

  const getOptionLabel = option =>
    !Boolean(option?.structured_formatting)
      ? ''
      : option.structured_formatting.main_text +
        '. ' +
        option.structured_formatting.secondary_text

  const bicolorText = opt => (
    <Typography variant="body2" color="grey">
      <Box component="span" sx={styles.listItemMainText}>
        {opt.structured_formatting.main_text}
        {'. '}
      </Box>
      <Box component="span" sx={styles.listItemSecondaryText}>
        {opt.structured_formatting.secondary_text}
      </Box>
    </Typography>
  )
  return (
    <Box sx={sx}>
      {/* //NOTE: html element isR in getAddressDetail fn - do not modify*/}
      <div id="google-map" />
      <Autocomplete
        options={predictions}
        getOptionLabel={getOptionLabel}
        onChange={(ev, value) => handleChangeAddress(value)}
        inputValue={input}
        onInputChange={(ev, value) => handleChangeInput(value)}
        autoHighlight
        autoComplete
        includeInputInList
        filterSelectedOptions
        filterOptions={x => x}
        noOptionsText={null}
        renderInput={params => (
          <TextField
            {...params}
            label={t('shipping-send-form:shipment:destination-address-label')}
            InputLabelProps={{ required: isRequired }}
          />
        )}
        fullWidth
        renderOption={(props, option) => (
          <li {...props}>{bicolorText(option)}</li>
        )}
        disableClearable
        classes={{ input: 'inputGPlacesAutocomplete' }}
      />
      <FormHelperText error>{error ? error : ' '}</FormHelperText>
    </Box>
  )
}
GPlacesAutocomplete.propTypes = {
  onChangeAddress: PropTypes.func,
  onChangeInput: PropTypes.func,
  error: PropTypes.string,
  countryRestrictions: PropTypes.array,
  sx: PropTypes.object,
  isRequired: PropTypes.bool,
}

export default GPlacesAutocomplete
